import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref, watch } from 'vue'
import LPopover from '@/components/core/Popover.vue'

interface ComboboxItem {
  value: string
  label: string
}

interface ComboboxProps {
  placeholder?: string
  value?: string
  items: ComboboxItem[]
  disableDeselection?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Combobox',
  props: {
    placeholder: null,
    value: null,
    items: null,
    disableDeselection: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  placeholder?: string
  value?: string
  items: ComboboxItem[]
  disableDeselection?: boolean
};




const input = ref<HTMLInputElement | null>(null)
const isOpen = ref(false)
watch(isOpen, async () => {
  if (isOpen.value) {
    await nextTick()
    setTimeout(() => input.value?.focus(), 50)
  } else {
    search.value = ''
  }
})
const search = ref('')
watch(search, () => {
  visualSelectedIndex.value = 0
})

const filtered = computed(() => {
  if (search.value) {
    const searchTerm = search.value.toLocaleLowerCase()
    return props.items.filter(
      (i) =>
        i.label.toLowerCase().includes(searchTerm) ||
        i.value.toLowerCase().includes(searchTerm),
    )
  } else {
    return props.items
  }
})

const visualSelectedIndex = ref(0)

const selected = computed({
  get() {
    return props.value
  },
  set(newValue) {
    emit('input', newValue)
  },
})

function onKeyDown(e: KeyboardEvent) {
  if (e.key === 'ArrowDown') {
    if (visualSelectedIndex.value < filtered.value.length) {
      visualSelectedIndex.value++
    }
  } else if (e.key === 'ArrowUp') {
    if (visualSelectedIndex.value > 0) {
      visualSelectedIndex.value--
    }
  } else if (e.key === 'Enter') {
    const selectedItem = filtered.value[visualSelectedIndex.value]
    if (selectedItem) {
      onSelect(selectedItem.value)
    }
  }
}

function onSelect(value: string) {
  if (props.disableDeselection && value === selected.value) {
    return
  }

  selected.value = value === selected.value ? undefined : value
  isOpen.value = false
}

return { __sfc: true,props, emit, input, isOpen, search, filtered, visualSelectedIndex, selected, onKeyDown, onSelect, LPopover }
}

})